module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.vpSelected) ? _c('div', {
    staticClass: "modal fade modal-block-vehicle",
    attrs: {
      "id": "modal-block-vehicle",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modal-block-vehicle-label"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal('close')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loadingModal),
      expression: "loadingModal",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(!_vm.requestSuccess && _vm.type == 'block') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Bloqueio temporário de veículo")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'block') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Bloqueio realizado com sucesso!")]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess && _vm.type == 'unblock') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Desbloqueio temporário de veículo")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'unblock') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Desbloqueio realizado com sucesso!")]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess && _vm.type == 'delete') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Exclusão permanente de veículo")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'delete') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Exclusão realizado com sucesso!")]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess && _vm.type == 'replace') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Substituição de TAG")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'replace') ? _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-block-vehicle-label"
    }
  }, [_vm._v("Substituição realizada com sucesso!")]) : _vm._e()]), _vm._v(" "), (_vm.vpSelected) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess) ? _c('div', {}, [_c('div', {}, [_c('p', [_vm._v("\n              Agregador:\n              "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.transportador))]), _vm._v("\n               \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Placa:\n              "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.plate))])]), _vm._v(" "), _c('p', [_vm._v("\n              N° TAG:\n              "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.tagSerialNumber == 0 ? '' : _vm.vpSelected.tagSerialNumber))])])]), _vm._v(" "), (_vm.type == 'replace') ? _c('div', {
    staticClass: "vehicle-box"
  }, [_c('div', {
    staticClass: "tag-box"
  }, [(!_vm.linkedTag) ? _c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("N° TAG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "only-numbers",
      rawName: "v-only-numbers"
    }, {
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.serialNumber),
      expression: "serialNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "data-vv-rules": "required|numeric"
    },
    domProps: {
      "value": (_vm.serialNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serialNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": String(_vm.serialNumber).length == 0 || !_vm.serialNumber,
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doReplaceTag()
      }
    }
  }, [_vm._v("Ativar")])]) : (_vm.linkedTag == 'success') ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("N° TAG: " + _vm._s(_vm.serialNumber == 0 ? '' : _vm.serialNumber))])]) : _c('div', [_c('div', {
    staticClass: "alert alert-danger inline"
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('button', {
    staticClass: "no-btn",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.linkedTag = !_vm.linkedTag
      }
    }
  }, [_c('i', {
    staticClass: "icon-repeat"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: (_vm.type == 'delete' || _vm.type == 'unblock') ? 'margin-b30' : ''
  }, [_c('button', {
    staticClass: "no-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.type == 'block') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doRequestBlock()
      }
    }
  }, [_vm._v("\n              Bloquear\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'unblock') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doRequestUnblock()
      }
    }
  }, [_vm._v("\n              Desbloquear\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'delete') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doRequestDelete()
      }
    }
  }, [_vm._v("\n              Excluir\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'block') ? _c('small', [_vm._v("O desbloqueio poderá ser feito na página de agregadores.")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess) ? _c('div', {
    staticClass: "content-box success text-center"
  }, [_c('p', [_vm._v("Agregador: "), _c('strong', {
    staticStyle: {
      "color": "#505050"
    }
  }, [_vm._v(_vm._s(_vm.vpSelected.transportador))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('p', [_vm._v("Placa: "), _c('strong', {
    staticStyle: {
      "border": "1px solid #848484",
      "padding": "3px",
      "border-radius": "3px"
    }
  }, [_vm._v(_vm._s(_vm.vpSelected.plate))])]), _vm._v(" "), _c('p', [_vm._v("Nº TAG: "), _c('strong', [_vm._v(_vm._s(_vm.vpSelected.tagSerialNumber == 0 ? '' : _vm.vpSelected.tagSerialNumber))])])]), _vm._v(" "), _c('img', {
    staticClass: "margin-10",
    attrs: {
      "src": "/static/Icon-check-circle.svg",
      "alt": "icon-check-circle"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('ok')
      }
    }
  }, [_vm._v("OK")])]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-1999b21f!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/modal-block-vehicle.vue
// module id = 2057
// module chunks = 1